import {IntermediatePart} from "../../intermediatePart";

export default class Range extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'range';
    this.partName = 'Range';
    this.translateId = "visualizer.kitchen.appliance.range";
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Range());
    // const rangeType = dbFeature.metaData && dbFeature.metaData["RangeType"];
    // if (!rangeType) {
    //   dbFeature.metaData["RangeType"] = ["ALL"];
    // }
  }

}
